(function($) {
  'use strict';
  var $readMoreDetails = $('.read-more');
  $readMoreDetails.each(function() {
    var $details = $(this);
    var $btn = $('<button class="read-more__btn"> Read less</button>');
    var $para = $details.find('p');
    $para.append($btn);
    $btn.on('click', function() {
      $details.removeAttr('open');
    });
  });
})(jQuery);
